import React  from 'react';
import {Black} from '../../Constants/ColorChart'
import styled from 'styled-components';
import { reportError } from './reportError';
const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size:14px;
    z-index: 1;
`;

const ModalContent = styled.div`
    background: #fff;
    padding: 20px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 0.3rem;
    outline: 0;
    width: 60%;
    max-width: 1141.8px;
`;

const ModalHeader = styled.h4`
    margin: 0;
    color: #343a40;
    font-size: 1.5rem;
`;

const ModalButton = styled.button`
    margin-top: 10px;
    padding: 5px 10px;
    border: none;
    border-radius: 5px;
    background-color: #007bff;
    color: white;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.3s;
    margin-left:10px;

    &:hover {
        background-color: #0056b3;
    }
`;

const ModalCancelButton = styled(ModalButton)`
    background-color: white;
    color: ${Black};
    border: 1px solid #ced4da;

    &:hover {
        background-color: #f8f9fa;
    }
`;

const InputField = styled.input`
    width: 100%;
    padding: 8px;
    margin-top: 10px;
    border: 1px solid #ced4da;
    border-radius: 5px;
    font-size: 14px;
`;

const TextAreaField = styled.textarea`
    width: 100%;
    padding: 8px;
    margin-top: 10px;
    border: 1px solid #ced4da;
    border-radius: 5px;
    font-size: 14px;
`;


const InputFieldWithLabel = ({ label, id, name, type, required }) => (
    <div className="">
        <label htmlFor={id}>{label}</label>
        <InputField name={name} type={type} id={id} required={required}  />
    </div>
);

const FormRow = styled.div`
    padding-top: 10px;
`;

const TextAreaFieldWithLabel = ({ label, id, name, required }) => (
    <div className="">
        <label htmlFor={id}>{label}</label>
        <TextAreaField id={id} name={name} required={required} rows={5} />
    </div>
);



const ReportErrorModal = ({ 
    onClose, 
    currentRow,
    reportErrorFn = reportError
}) => {

    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
        
            // Read the form data
            const form = e.target;
            const formData = new FormData(form);
            const formJson = Object.fromEntries(formData.entries());
            console.log(formJson)
            
            await onClose();
            await reportErrorFn(
                currentRow.id,
                currentRow.metadata.name,
                currentRow.url,
                formJson.subject,
                formJson.description
            );

        } catch (error) {
            console.error('Error reporting the error:', error);
        }
    }

    return (
        <ModalContainer>
            <ModalContent>
                <ModalHeader>Report Error</ModalHeader>
                <div className="modal-body">
                    <form method="post" onSubmit={handleSubmit} data-testid="report-error-form">
                        <div className="show FormPanel container-fluid">
                            <FormRow>
                                <div className="col-md-12">
                                    <InputFieldWithLabel label="Subject" name="subject" type="text" id="subject" required  />
                                </div>
                            </FormRow>
                            <FormRow>
                                <div className="col-md-12">
                                    <TextAreaFieldWithLabel label="Description" name="description" id="description" required  />
                                </div>
                            </FormRow>

                            
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="buttons text-end">
                                        <ModalButton type="submit" >Report Error</ModalButton>
                                        <ModalCancelButton type="button" onClick={onClose}>Cancel</ModalCancelButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </ModalContent>
        </ModalContainer>
    );
}

export default ReportErrorModal; 